// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"86e28541","831":"420ddf06"}[chunkId] + ".chunk.js";
};